import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import * as Payment from "payment";
import { TranslationLoaderService } from "src/app/core/service/translation-loader.service";
import { CreditCardData } from "src/app/modules/new-payment/new-payment/models/CreditCardData";
import { locale as english } from "./i18n/en-US";
import { locale as spanish } from "./i18n/es-ES";
import { locale as portuguese } from "./i18n/pt-BR";

@Component({
    selector: "app-credit-card-form",
    templateUrl: "./credit-card-form.component.html",
    styleUrls: ["./credit-card-form.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class CreditCardFormComponent implements OnInit {
    @Input() requirePhone = false;
    @Input() phone = '';

    public creditCardData: CreditCardData;
    creditCardForm: UntypedFormGroup;
    focused: string;

    constructor(private _formBuilder: UntypedFormBuilder, private _translationLoaderService: TranslationLoaderService) {
        this._translationLoaderService.loadTranslations(english, portuguese, spanish);
    }

    ngOnInit(): void {
        this.clear();
        
        // Preencher automaticamente o telefone se fornecido
        if (this.phone && this.requirePhone) {
            this.creditCardData.phone = this.phone;
            if (this.creditCardForm.get('phone')) {
                this.creditCardForm.get('phone').setValue(this.phone);
            }
        }
    }

    public isValid(): boolean {
        return !this.creditCardForm.invalid;
    }

    createCreditCardForm(): UntypedFormGroup {
        const formGroup: any = {
            cardNumber: ["", [Validators.required, this.creditCardNumber]],
            holder: ["", [Validators.required, this.holderName]],
            securityCode: ["", [Validators.required, Validators.minLength(3), Validators.maxLength(4)]],
            expirationDate: ["", [Validators.required, this.expirationDate]],
            isDefault: [false]
        };

        if (this.requirePhone) {
            formGroup.phone = ["", []];
        }

        return this._formBuilder.group(formGroup);
    }

    expirationDate: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
        return control.value &&
            control.dirty &&
            (control.value.length != 4 ||
                !Payment.fns.validateCardExpiry(control.value.substring(0, 2), control.value.substring(2)))
            ? { expirationDate: true }
            : null;
    };

    creditCardNumber: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
        return control.value && control.dirty && !Payment.fns.validateCardNumber(control.value)
            ? { creditCardNumber: true }
            : null;
    };

    securityCode: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
        return control.value && control.dirty && !Payment.fns.validateCardCVC(control.value)
            ? { securityCode: true }
            : null;
    };

    holderName: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
        const parts = control.value.split(" ");
        return control.value && control.dirty && parts.length <= 1 ? { holderName: true } : null;
    };

    get cardMask(): string {
        if (Payment.fns.cardType(this.creditCardData.number) == "amex") return "0000 000000 00000";
        else return "0000 0000 0000 0000";
    }

    clear(): void {
        this.creditCardData = new CreditCardData();
        this.creditCardForm = this.createCreditCardForm();
        this.focused = "";
    }
}
